import api from '@/api/applicantStatusNotificationTemplateConfig'

const state = {

}

const actions = {
  getCompanyApplicantStatusNotificationTemplateConfig (context, { companyId, configList }) {
    return api.getCompanyApplicantStatusNotificationTemplateConfig(companyId, configList)
  },
  deleteApplicantStatusNotificationTemplateConfig (context, companyId) {
    return api.deleteApplicantStatusNotificationTemplateConfig(companyId)
  },
  createApplicantStatusNotificationTemplateConfig (context, { companyId, configList }) {
    return api.createApplicantStatusNotificationTemplateConfig(companyId, configList)
  },
  updateApplicantStatusNotificationTemplateConfig (context, { companyId, configList }) {
    return api.updateApplicantStatusNotificationTemplateConfig(companyId, configList)
  },
  getCompanyApplicantStatusEmailTemplateList (context, companyId) {
    return api.getCompanyApplicantStatusEmailTemplateList(companyId)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
